jQuery(document).ready(function($){

	/*
	 * Carousel s šipkou
	 */
	$("#jq-owl-arrow").owlCarousel({
		navigation: true,
		navigationText: [false, '<i class="icon icon--angle-right owl-next-icon"></i>'],
		slideSpeed: 300,
		paginationSpeed: 400,
		singleItem: true,
		autoHeight: true,
		responsiveRefreshRate: 500
	});

	/*
	 * Carousel bez šipky
	 */
	$("#jq-owl-default").owlCarousel({
		navigation: false,
		slideSpeed: 300,
		paginationSpeed: 400,
		singleItem: true,
		autoHeight: true,
		responsiveRefreshRate: 500
	});

});